import { AfterViewInit, Directive, ElementRef, Input, Renderer2, inject } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[psbButton]',
    standalone: true,
})
export class PsbButtonDirective implements AfterViewInit {
    private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
    private renderer = inject(Renderer2);

    @Input() psbButton = true;


    ngAfterViewInit(): void {
        if (!this.psbButton) return;

        const element = this.elementRef.nativeElement;
        const buttonContent = element.querySelector('[data-sirius-button-content]');

        if (buttonContent) {
            const img = this.renderer.createElement('img');
            this.renderer.setAttribute(img, 'src', 'assets/psb-verification.png');
            this.renderer.setAttribute(img, 'alt', 'PSB verification');
            this.renderer.setAttribute(img, 'height', '20');
            this.renderer.setAttribute(img, 'width', '20');

            this.renderer.insertBefore(buttonContent, img, buttonContent.firstChild);
        }
    }
}
